import { CommonHTTP } from '@/abstract'
import {
  DomainAddToCartResponseData,
  DomainCheckResponseData
} from '@/core/ryanada'
import { DomainModel } from '@/models'
import {
  URL_CHECK_DOMAIN,
  URL_CONF_DOMAIN,
  URL_UPDATE_DOMAIN_PERIOD
} from '@/utils'

interface Accumulator {
  domains: { [key: string]: string }[]
  update: { [key: string]: string }[]
}

export class DomainHTTP extends CommonHTTP {
  public async post(domains: DomainModel[]): Promise<boolean> {
    const formData = this.mergeData(domains)
    await this.configureDomains(formData)
    return true
  }

  private mergeData(domainModels: DomainModel[]): FormData {
    const formData = new FormData()

    const accumulator = domainModels.reduce<Accumulator>(
      (acc, curr) => {
        const i = Number.parseInt(curr.cartIndex)
        const name = curr.getName()
        const update = 'true'
        acc.domains.push({ [i]: name })
        acc.update.push({ [i]: update })
        return acc
      },
      {
        domains: [],
        update: []
      }
    )

    formData.append('domain', JSON.stringify(accumulator.domains))
    formData.append('update', JSON.stringify(accumulator.update))

    domainModels.forEach((model) => {
      for (const iterator of model
        .getAcceptedRequestData(model.cartIndex)
        .formData.entries()) {
        const [key, value] = iterator
        if (key !== 'domain' && key !== 'update') {
          formData.append(key, value.toString())
        }
      }
    })

    return formData
  }

  private async configureDomains(formData: FormData): Promise<void> {
    const response = await fetch(URL_CONF_DOMAIN, {
      method: 'POST',
      mode: 'cors',
      body: formData
    })

    this.handleReloadPage(response)
  }

  public async updatePeriod(domain: DomainModel): Promise<boolean> {
    const { formData } = domain.getAcceptedRequestData(domain.cartIndex)
    await this.handleUpdateDomainPeriod(formData)
    return true
  }

  private async handleUpdateDomainPeriod(formData: FormData): Promise<void> {
    const response = await fetch(URL_UPDATE_DOMAIN_PERIOD, {
      method: 'POST',
      mode: 'cors',
      body: formData
    })

    this.handleReloadPage(response)
  }

  public async checkDomain(
    formData: FormData
  ): Promise<DomainCheckResponseData> {
    const response = await fetch(URL_CHECK_DOMAIN, {
      method: 'POST',
      body: formData
    })

    const responseData: DomainCheckResponseData = await response.json()

    return responseData
  }

  public async addToCart(
    formData: FormData
  ): Promise<DomainAddToCartResponseData> {
    const response = await fetch('cart.php', {
      method: 'POST',
      body: formData
    })

    const data: DomainAddToCartResponseData = await response.json()

    return data
  }
}
